import { CurrencyResponseType, InstrumentType } from 'data/Instrument/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getAll = () =>
  fetchApi<InstrumentType[]>({
    method: 'GET',
    url: getApiUrl('mercury-gateway/v1/instruments')
  })

export const getCurrencies = () =>
  fetchApi<CurrencyResponseType>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/markets/exchange/currencies?purpose=all')
  })
